import { ReactElement, useState } from 'react';
import { SectionVariant } from 'components/common/Sections/SectionTitle';
import { Folder } from '@novaheal/types';
import { ChevronRightIcon } from 'assets/icons/v2';
import { Section } from '../Sections/Section';
import { FolderBox } from './FolderBox';

type Props = {
  folders: Folder[] | undefined;
  maxNumOfSubfolders?: number;
};

export const SubfoldersStack = ({ maxNumOfSubfolders = 2, folders }: Props): ReactElement => {
  const [showsLess, setShowsLess] = useState<boolean>(false);

  const filteredFolders = folders?.filter(
    (folder) =>
      folder.totalNumOfArticles > 0 ||
      folder.totalNumOfMedications > 0 ||
      folder.totalNumOfSubfolders > 0
  );
  const numOfSubfolders = filteredFolders?.length || 0;
  const hasShowLessButton = numOfSubfolders > maxNumOfSubfolders;
  const slicedSubfolders = showsLess ? filteredFolders?.slice(0, 2) : filteredFolders;

  const buttonContent = (): JSX.Element | string => {
    return !showsLess ? (
      'Weniger sehen'
    ) : (
      <>
        Alle ansehen <ChevronRightIcon />
      </>
    );
  };

  return (
    <Section
      variant={SectionVariant.FOLDER}
      hasButton={hasShowLessButton}
      buttonContent={buttonContent()}
      onClickButton={() => setShowsLess((prev) => !prev)}
    >
      {slicedSubfolders?.map(
        (subFolder: Folder): ReactElement => (
          <FolderBox
            key={subFolder.id}
            numOfArticles={subFolder.totalNumOfArticles}
            numOfSubfolders={subFolder.totalNumOfSubfolders}
            numOfMedications={subFolder.totalNumOfMedications}
            name={subFolder.name}
            id={subFolder.id}
            image={subFolder.image}
          />
        )
      )}
    </Section>
  );
};
